import { componentName, ContainerClass } from './ContainerClass';

customElements.define(componentName, ContainerClass);

export { ContainerClass, componentName };
